import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useCompany } from "../hooks/useCompany";

export default function DemoBanner() {
  const { isDemo } = useCompany();
  const { t } = useTranslation();

  if (!isDemo) return null;

  return (
    <div className="no-print bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-between text-sm">
      <div className="flex items-center gap-2">
        <span className="text-amber-600 font-semibold">{t("demo_banner_label")}</span>
        <span className="text-amber-700">{t("demo_banner_text")}</span>
      </div>
      <Link
        to="/ManageSubscription"
        className="bg-amber-500 hover:bg-amber-600 text-white text-xs font-semibold px-3 py-1 rounded transition"
      >
        {t("demo_subscribe_btn")}
      </Link>
    </div>
  );
}
